<template lang="pug">
  .uploader(@dragenter='OnDragEnter' @dragleave='OnDragLeave' @dragover.prevent='' @drop='onDrop' :class='{ dragging: isDragging }')
    div(v-show='!image.length')
      i.fas.fa-cloud-upload-alt.font-big
      p Arrastra tus archivos aquí...
      div ó
      .field.has-addons.has-addons-centered
        .file.is-small.is-dark
          label.file-label
            input.file-input#fileInput(type='file' @change='onInputChange')
            span.file-cta
              span.file-icon
                i.fas.fa-upload
              span.file-label
                | Seleccione un archivo...
    .images-preview(v-show='image.length')
      .img-wrapper
        img(:src='image')
        .details.has-text-centered
          span.name(v-text='file.name')
          span.size(v-text='getFileSize(file.size)')
          button.button.is-danger.is-small.is-rounded.is-pulled-right(@click="quitarImagen()" :disabled='isDisabled')
            i.fas.fa-times 
            | &nbsp Eliminar
    .upload-control(v-show='image.length')
      .columns
        .column.is-12
          label.has-text-dark(for='file') Selecciona otro archivo ...
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  var FormData = require('form-data')

  export default {
    name: 'Attachment',
    components: { Loader },
    props: {
      isDisabled: {
        type: Boolean,
        default: false
      },
    },
    data () {
      return {
        isDragging: false,
        dragCount: 0,
        file: '',
        image: '',
        ismultiple: false,
        input: null
      }
    },
    watch: {
      file() {
        this.upload()
      }
    },
    methods: {
      OnDragEnter(e) {
        e.preventDefault()
        
        this.dragCount++
        this.isDragging = true
        return false
      },
      OnDragLeave(e) {
      e.preventDefault()
      this.dragCount--
      if (this.dragCount <= 0)
          this.isDragging = false
      },
      onInputChange(e) {
        console.log(e)
        const files = e.target.files
        Array.from(files).forEach(f => this.addImage(f))
      },
      onDrop(e) {
        e.preventDefault();
        e.stopPropagation();
        this.isDragging = false;
        const files = e.dataTransfer.files
        Array.from(files).forEach(f => this.addImage(f))
      },
      addImage(file) {
        let max_images = 0
        if (!this.ismultiple) {
          max_images = 1
        } else {
          max_images = 10
        }

        if (this.image.length >= max_images) {
          let toast = this.$toasted.show(`Ya ha seleccionado una imagen antes.`, { 
            theme: "toasted-primary", 
            position: "bottom-right", 
            duration : 1500,
            iconPack: 'fontawesome',
            icon: 'exclamation-triangle',
            action : {
              text : 'Ok',
              onClick : (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
          })
            return
        } else {
          if (!file.type.match('image.*')) {
            let toast = this.$toasted.show(`${file.name} no es una imagen.`, { 
              theme: "toasted-primary", 
              position: "bottom-right", 
              duration : 1500,
              iconPack: 'fontawesome',
              icon: 'exclamation-triangle',
              action : {
                text : 'Ok',
                onClick : (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
            })
            return
          }
          this.file = file
          const img = new Image(),
          reader = new FileReader()
          reader.onload = (e) => this.image = e.target.result
          reader.readAsDataURL(file)
        }
      },
      getFileSize(size) {
        const fSExt = ['Bytes', 'KB', 'MB', 'GB']
        let i = 0
          
        while(size > 900) {
          size /= 1024
          i++
        }
        return `${(Math.round(size * 100) / 100)} ${fSExt[i]}`
      },
      upload() {
        this.$emit('changeFile', this.file)
      },
      quitarImagen (indice) {
        this.file = ''
        this.image = ''
        this.$emit('changeFile', null)
      }
    }
  }
</script>


<style lang="scss" scoped>
  .uploader {
    width: 100%;
    background: whitesmoke;
    color: #363636;
    padding: 40px 15px;
    text-align: center;
    border-radius: 10px;
    border: 3px dashed #363636;
    font-size: 20px;
    position: relative;

    &.dragging {
      background: #363636;
      color: whitesmoke;
      border: 3px dashed #363636;
      // .file-input label {
      //   background: #363636;
      //   color: whitesmoke;
      // }
    }

    i.font-big {
      font-size: 85px;
    }
    // .file-input {
    //   width: 200px;
    //   margin: auto;
    //   height: 68px;
    //   position: relative;
    //   label,
    //   input {
    //     background: #fff;
    //     color: #2196F3;
    //     width: 100%;
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     padding: 10px;
    //     border-radius: 4px;
    //     margin-top: 7px;
    //     cursor: pointer;
    //   }
    //   input {
    //     opacity: 0;
    //     z-index: -2;
    //   }
    // }
    .images-preview {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      .img-wrapper {
        width: 160px;
        display: flex;
        flex-direction: column;
        margin: 10px;
        height: 150px;
        justify-content: space-between;
        background: whitesmoke;
        box-shadow: 5px 5px 20px #363636;
        img {
          max-height: 105px;
        }
      }
      .details {
        font-size: 12px;
        background: #363636;
        color: whitesmoke;
        display: flex;
        flex-direction: column;
        align-items: self-start;
        padding: 3px 6px;
        .name {
          overflow: hidden;
          height: 18px;
        }
      }
    }
    .upload-control {
      // position: absolute;
      // width: 100%;
      // background: #fff;
      // top: 0;
      // left: 0;
      // border-top-left-radius: 7px;
      // border-top-right-radius: 7px;
      // padding: 10px;
      // padding-bottom: 4px;
      // text-align: right;
      button, label {
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/AttachmentGen.vue